<div>
    <div class="container">
        <div class="search-footer-container">
            <div class="search-footer">
                <div class="search-btn">
                    <p>{{getResultLabel()}}</p>
                    <button *ngIf="hasLoadMore()" tfFeaturedButton (click)="incrementOffset()">{{getButtonLabel()}}</button>
                </div>

                <div class="not-finding" [ngClass]="{'d-none': customArray}" *ngIf="showNotFindingLink()">
                    <span>Still not finding it?</span>
                    <a [href]="getUrl()" target="_blank">
                        Go to TaqMan Custom Assay Design Tools
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.72314 2.48926C10.4846 2.48926 12.7231 4.72783 12.7231 7.48926C12.7231 10.2507 10.4846 12.4893 7.72314 12.4893C4.96172 12.4893 2.72314 10.2507 2.72314 7.48926C2.72314 4.72783 4.96172 2.48926 7.72314 2.48926ZM7.72314 0.489258C3.85715 0.489258 0.723145 3.62326 0.723145 7.48926C0.723145 11.3553 3.85715 14.4893 7.72314 14.4893C11.5891 14.4893 14.7231 11.3553 14.7231 7.48926C14.7231 5.63274 13.9856 3.85226 12.6729 2.53951C11.3601 1.22676 9.57966 0.489258 7.72314 0.489258ZM6.72314 6.96926V11.3693H8.72314V6.96926H6.72314ZM6.72314 3.72926V5.72926H8.72314V3.72926H6.72314Z" fill="#3194E9"/>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
